import React from "react";
import { CheckCircle2, ChevronRight } from "lucide-react";

const perks = [
  "Genuine Eli Lilly Mounjaro (cold‑chain handled)",
  "Body composition analysis every 4 weeks (BIA scan)",
  "In‑house dietician with Indian meal plans",
  "Certified physiotherapist for pain‑free movement",
  "Personalised dose titration by an endocrinologist",
  "Unlimited WhatsApp support, 7 days a week",
  "Transparent pricing — no hidden fees, ever",
];

export const MounjaroSpotlight = ({ onBookClick }) => {
  return (
    <section id="mounjaro" data-testid="mounjaro-section" className="py-24 md:py-32 bg-[#FAFAF7]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="rounded-[36px] bg-white border border-[#EAE7E1] overflow-hidden grid grid-cols-1 lg:grid-cols-12">
          <div className="lg:col-span-6 p-10 md:p-14">
            <span className="inline-flex items-center gap-2 rounded-full bg-[#E8F0E9] px-3.5 py-1.5 text-xs font-semibold text-[#779D7C]">
              The Mounjaro Programme
            </span>
            <h2 className="mt-5 font-display text-4xl md:text-5xl leading-[1.05] text-[#242220]">
              Hyderabad's most searched <em className="text-[#EB8771]">Mounjaro doctor</em> — for good reason.
            </h2>
            <p className="mt-5 text-[#38312C] leading-relaxed">
              A 12‑week structured programme that blends the right medication, weekly clinical review,
              nutrition coaching and on‑demand support. Quietly effective, and genuinely safe.
            </p>

            <ul className="mt-8 space-y-3">
              {perks.map((p, i) => (
                <li key={i} data-testid={`perk-${i}`} className="flex items-start gap-3 text-[15px] text-[#242220]">
                  <CheckCircle2 className="h-5 w-5 mt-0.5 text-[#779D7C]" strokeWidth={1.7} />
                  <span>{p}</span>
                </li>
              ))}
            </ul>

            <button
              data-testid="mounjaro-cta"
              onClick={onBookClick}
              className="mt-10 inline-flex items-center gap-2 rounded-full bg-[#779D7C] hover:bg-[#5f8466] text-white px-7 py-4 text-[15px] font-medium transition-all hover:scale-[1.02]"
            >
              Take the Eligibility Quiz <ChevronRight className="h-4 w-4" />
            </button>
          </div>

          <div className="lg:col-span-6 bg-[#E8F0E9] relative min-h-[380px] lg:min-h-[560px]">
            <img
              src="https://www.asiandiabeticcenter.in/wp-content/uploads/2026/03/image.jpeg"
              alt="Dr. Shalini Patlolla with patient at Asian Diabetes Thyroid Hormone Superspeciality Centre"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#242220]/25 via-transparent to-transparent" />
            <div className="absolute top-6 right-6 rounded-full bg-white/95 px-4 py-1.5 text-xs font-semibold text-[#779D7C] border border-[#E8F0E9]">
              Once‑weekly injection
            </div>
            <div className="absolute bottom-6 left-6 right-6 rounded-2xl bg-white/95 border border-white p-5 backdrop-blur">
              <p className="text-[10px] tracking-[0.2em] uppercase text-[#6B6660]">12‑week outcome</p>
              <p className="font-display text-2xl text-[#242220] mt-1">Typically 8–15 kg</p>
              <p className="text-xs text-[#6B6660] mt-1">with dual GIP/GLP‑1 action</p>
            </div>
          </div>
        </div>

        <p className="mt-6 text-xs text-[#6B6660] max-w-3xl">
          Tirzepatide (Mounjaro/Zepbound) is FDA approved; in India, prescribed by qualified endocrinologists
          where clinically appropriate. Individual results vary.
        </p>
      </div>
    </section>
  );
};
